// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3WjC2","large":"styles_large__230pm"};